/* =============================================================================
   CONFIGURATEUR DE PRÉSENTOIRS — v1 (2026-10-01)
   Rendu par snippets/pcfg-presentoir.liquid (template page.configurateur-presentoirs.json)

   Présentoir = parallélépipède rectangle sans base :
   - 4 faces latérales pleine hauteur : avant et arrière pleine largeur, côtés gauche/droit
     entre les deux ;
   - un dessus inséré entre les 4 faces, affleurant en haut.
   - Chaque face latérale peut être en pegboard (perforée, débouchante) → panneau 21 mm,
     sinon 15 mm. Dessus : 15 mm.
   - Couleur au choix pour chaque face (bouleau inclus, autre couleur +30 % sur la matière).

   Tarif (aligné sur le configurateur de casiers, LC_PRICING) :
     matière 230 €/m² × facteur d'épaisseur (15 mm −10 %, 21 mm +10 %)
     + découpe 5,75 € par panneau + faces teintées +30 % sur leur matière
     → finition & contrôle +10 % → + perforations pegboard 250 €/m² de face perforée.
   Panier : produit « matiere-au-m2-configurateur-presentoirs » à 1 € (quantité = prix arrondi
   à l'euro supérieur). Prix unitaire lu dans data-unit-price → s'adapte si le variant change.

   Fichiers : snippets/pcfg-presentoir.liquid, assets/pcfg-presentoir.js, assets/pcfg-presentoir.css
   Dépend de assets/three.min.js (r128, déjà utilisé par les casiers) ; repli SVG sans WebGL.
============================================================================= */
(function () {
  'use strict';

  var root = document.getElementById('pcfg');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  /* ---------------------------------------------------------------------------
     Traductions (fr par défaut)
  --------------------------------------------------------------------------- */
  var I18N = {
    fr: {
      h1: 'Configurez votre présentoir sur mesure',
      intro: 'Choisissez les dimensions, les faces en pegboard et la couleur de chaque face. Prix immédiat, fabriqué en France.',
      cardDims: '1 · Dimensions', width: 'Largeur', height: 'Hauteur', depth: 'Profondeur',
      dimsHelp: 'Dimensions extérieures, en cm. Largeur et profondeur de 20 à 120 cm, hauteur de 20 à 200 cm.',
      cardFaces: '2 · Faces et couleurs',
      allFaces: 'Toutes les faces', allFacesHelp: 'Applique une couleur à toutes les faces d’un coup.',
      faceFront: 'Face avant', faceBack: 'Face arrière', faceLeft: 'Côté gauche', faceRight: 'Côté droit', faceTop: 'Dessus',
      pegboard: 'Pegboard',
      pegHelp: 'Face perforée sur toute sa surface (trous débouchants Ø 6 mm, entraxe 30 mm) pour accrocher les accessoires. Une face pegboard est en 21 mm, les autres en 15 mm.',
      topHelp: 'Le dessus est inséré entre les quatre faces, affleurant en haut. Pas de fond : le présentoir est ouvert en bas.',
      colorHelp: 'Bouleau inclus. Autre couleur : +30 % sur la matière de la face.',
      preview: 'Aperçu 3D',
      previewHelp: 'Glissez pour tourner, molette ou pincement pour zoomer. Cliquez une face pour la régler.',
      cardRecap: '2 · Récapitulatif',
      outer: 'Dimensions hors-tout', pegFaces: 'Faces pegboard', none: 'Aucune', wood: 'Panneau utilisé', woodUnit: 'm²',
      total: 'Prix total', priceUnit: 'TTC · livraison calculée au paiement', breakdown: 'Détail du prix',
      lineWood: 'Bois', lineThick: 'Épaisseurs (15 mm −10 %, 21 mm +10 %)', lineCut: 'Découpe sur mesure',
      lineColor: 'Faces teintées (+30 %)', lineFinish: 'Finition & contrôle (+10 %)', linePeg: 'Perforations pegboard',
      lineTotal: 'Total TTC', panels: 'panneaux',
      reset: 'Réinitialiser', resetDone: 'Configuration réinitialisée', copyLink: 'Copier le lien', linkCopied: 'Lien copié',
      addToCart: 'Ajouter au panier', adding: 'Ajout…', cartFail: 'Impossible d’ajouter au panier. Réessayez ou contactez-nous.',
      missingVariant: 'Produit de facturation introuvable : contactez-nous pour commander.',
      cartTitle: 'Présentoir sur mesure', sFront: 'Avant', sBack: 'Arrière', sLeft: 'Gauche', sRight: 'Droite', sTop: 'Dessus', hint: 'Cliquez sur une face pour choisir sa couleur et ses perforations', facesLabel: 'Faces', applyAll: 'Appliquer cette couleur à toutes les faces', close: 'Fermer', color: 'Couleur', colorsTile: 'Couleurs', mixed: 'Personnalisées', holes: 'trous', allFacesName: 'Toutes faces', thickness: 'Épaisseur',
      madeIn: 'Fabriqué en France · Bois certifié', contact: 'Un projet particulier ?', contactLink: 'Contactez-nous',
      noWebgl: 'Aperçu simplifié (3D indisponible sur cet appareil)',
      c_birch: 'Bouleau (beige clair)', c_green: 'Vert', c_blue: 'Bleu', c_yellow: 'Jaune', c_orange: 'Orange',
      c_red: 'Rouge', c_purple: 'Violet', c_black: 'Noir', c_white: 'Blanc'
    },
    en: {
      h1: 'Configure your custom display stand',
      intro: 'Choose the dimensions, the pegboard faces and the colour of each face. Instant price, made in France.',
      cardDims: '1 · Dimensions', width: 'Width', height: 'Height', depth: 'Depth',
      dimsHelp: 'Outer dimensions in cm. Width and depth 20 to 120 cm, height 20 to 200 cm.',
      cardFaces: '2 · Faces & colours',
      allFaces: 'All faces', allFacesHelp: 'Applies one colour to every face at once.',
      faceFront: 'Front', faceBack: 'Back', faceLeft: 'Left side', faceRight: 'Right side', faceTop: 'Top',
      pegboard: 'Pegboard',
      pegHelp: 'Face perforated over its whole surface (through holes Ø 6 mm, 30 mm pitch) to hang accessories. A pegboard face is 21 mm thick, the others 15 mm.',
      topHelp: 'The top is fitted between the four faces, flush at the top. No base: the stand is open at the bottom.',
      colorHelp: 'Birch included. Other colours: +30 % on the material of that face.',
      preview: '3D preview',
      previewHelp: 'Drag to rotate, scroll or pinch to zoom. Click a face to edit it.',
      cardRecap: '2 · Summary',
      outer: 'Overall dimensions', pegFaces: 'Pegboard faces', none: 'None', wood: 'Board used', woodUnit: 'm²',
      total: 'Total price', priceUnit: 'incl. VAT · shipping calculated at checkout', breakdown: 'Price breakdown',
      lineWood: 'Wood', lineThick: 'Thicknesses (15 mm −10 %, 21 mm +10 %)', lineCut: 'Custom cutting',
      lineColor: 'Coloured faces (+30 %)', lineFinish: 'Finishing & inspection (+10 %)', linePeg: 'Pegboard perforations',
      lineTotal: 'Total incl. VAT', panels: 'panels',
      reset: 'Reset', resetDone: 'Configuration reset', copyLink: 'Copy link', linkCopied: 'Link copied',
      addToCart: 'Add to cart', adding: 'Adding…', cartFail: 'Could not add to cart. Please try again or contact us.',
      missingVariant: 'Billing product not found: please contact us to order.',
      cartTitle: 'Custom display stand', sFront: 'Front', sBack: 'Back', sLeft: 'Left', sRight: 'Right', sTop: 'Top', hint: 'Click a face to choose its colour and perforations', facesLabel: 'Faces', applyAll: 'Apply this colour to all faces', close: 'Close', color: 'Colour', colorsTile: 'Colours', mixed: 'Custom', holes: 'holes', allFacesName: 'All faces', thickness: 'Thickness',
      madeIn: 'Made in France · Certified wood', contact: 'A special project?', contactLink: 'Contact us',
      noWebgl: 'Simplified preview (3D unavailable on this device)',
      c_birch: 'Birch (light beige)', c_green: 'Green', c_blue: 'Blue', c_yellow: 'Yellow', c_orange: 'Orange',
      c_red: 'Red', c_purple: 'Purple', c_black: 'Black', c_white: 'White'
    },
    de: {
      h1: 'Konfigurieren Sie Ihr Display nach Maß',
      intro: 'Wählen Sie die Maße, die Pegboard-Seiten und die Farbe jeder Seite. Sofortiger Preis, hergestellt in Frankreich.',
      cardDims: '1 · Maße', width: 'Breite', height: 'Höhe', depth: 'Tiefe',
      dimsHelp: 'Außenmaße in cm. Breite und Tiefe 20 bis 120 cm, Höhe 20 bis 200 cm.',
      cardFaces: '2 · Seiten & Farben',
      allFaces: 'Alle Seiten', allFacesHelp: 'Eine Farbe für alle Seiten auf einmal.',
      faceFront: 'Vorderseite', faceBack: 'Rückseite', faceLeft: 'Linke Seite', faceRight: 'Rechte Seite', faceTop: 'Deckplatte',
      pegboard: 'Pegboard',
      pegHelp: 'Vollflächig gelochte Seite (durchgehende Löcher Ø 6 mm, Raster 30 mm) zum Einhängen von Zubehör. Eine Pegboard-Seite ist 21 mm stark, die anderen 15 mm.',
      topHelp: 'Die Deckplatte sitzt zwischen den vier Seiten, oben bündig. Kein Boden: das Display ist unten offen.',
      colorHelp: 'Birke inklusive. Andere Farbe: +30 % auf das Material der Seite.',
      preview: '3D-Vorschau',
      previewHelp: 'Ziehen zum Drehen, Mausrad oder Zwei-Finger zum Zoomen. Klicken Sie auf eine Seite, um sie einzustellen.',
      cardRecap: '2 · Zusammenfassung',
      outer: 'Außenmaße', pegFaces: 'Pegboard-Seiten', none: 'Keine', wood: 'Plattenfläche', woodUnit: 'm²',
      total: 'Gesamtpreis', priceUnit: 'inkl. MwSt. · Versand an der Kasse berechnet', breakdown: 'Preisdetails',
      lineWood: 'Holz', lineThick: 'Stärken (15 mm −10 %, 21 mm +10 %)', lineCut: 'Zuschnitt nach Maß',
      lineColor: 'Farbige Seiten (+30 %)', lineFinish: 'Finish & Kontrolle (+10 %)', linePeg: 'Pegboard-Lochung',
      lineTotal: 'Gesamt inkl. MwSt.', panels: 'Platten',
      reset: 'Zurücksetzen', resetDone: 'Konfiguration zurückgesetzt', copyLink: 'Link kopieren', linkCopied: 'Link kopiert',
      addToCart: 'In den Warenkorb', adding: 'Wird hinzugefügt…', cartFail: 'Hinzufügen fehlgeschlagen. Bitte erneut versuchen oder uns kontaktieren.',
      missingVariant: 'Abrechnungsprodukt nicht gefunden: bitte kontaktieren Sie uns.',
      cartTitle: 'Display nach Maß', sFront: 'Vorne', sBack: 'Hinten', sLeft: 'Links', sRight: 'Rechts', sTop: 'Oben', hint: 'Klicken Sie auf eine Seite, um Farbe und Lochung zu wählen', facesLabel: 'Seiten', applyAll: 'Diese Farbe für alle Seiten übernehmen', close: 'Schließen', color: 'Farbe', colorsTile: 'Farben', mixed: 'Individuell', holes: 'Löcher', allFacesName: 'Alle Seiten', thickness: 'Stärke',
      madeIn: 'Hergestellt in Frankreich · Zertifiziertes Holz', contact: 'Ein besonderes Projekt?', contactLink: 'Kontakt',
      noWebgl: 'Vereinfachte Vorschau (3D auf diesem Gerät nicht verfügbar)',
      c_birch: 'Birke (helles Beige)', c_green: 'Grün', c_blue: 'Blau', c_yellow: 'Gelb', c_orange: 'Orange',
      c_red: 'Rot', c_purple: 'Lila', c_black: 'Schwarz', c_white: 'Weiß'
    },
    es: {
      h1: 'Configure su expositor a medida',
      intro: 'Elija las dimensiones, las caras de pegboard y el color de cada cara. Precio inmediato, fabricado en Francia.',
      cardDims: '1 · Dimensiones', width: 'Ancho', height: 'Alto', depth: 'Fondo',
      dimsHelp: 'Dimensiones exteriores en cm. Ancho y fondo de 20 a 120 cm, alto de 20 a 200 cm.',
      cardFaces: '2 · Caras y colores',
      allFaces: 'Todas las caras', allFacesHelp: 'Aplica un color a todas las caras a la vez.',
      faceFront: 'Cara delantera', faceBack: 'Cara trasera', faceLeft: 'Lado izquierdo', faceRight: 'Lado derecho', faceTop: 'Tapa',
      pegboard: 'Pegboard',
      pegHelp: 'Cara perforada en toda su superficie (agujeros pasantes Ø 6 mm, paso 30 mm) para colgar accesorios. Una cara pegboard es de 21 mm, las demás de 15 mm.',
      topHelp: 'La tapa va encajada entre las cuatro caras, enrasada arriba. Sin base: el expositor está abierto por abajo.',
      colorHelp: 'Abedul incluido. Otro color: +30 % sobre el material de la cara.',
      preview: 'Vista 3D',
      previewHelp: 'Arrastre para girar, rueda o pellizco para hacer zoom. Haga clic en una cara para ajustarla.',
      cardRecap: '2 · Resumen',
      outer: 'Dimensiones totales', pegFaces: 'Caras pegboard', none: 'Ninguna', wood: 'Tablero utilizado', woodUnit: 'm²',
      total: 'Precio total', priceUnit: 'IVA incl. · envío calculado al pagar', breakdown: 'Detalle del precio',
      lineWood: 'Madera', lineThick: 'Espesores (15 mm −10 %, 21 mm +10 %)', lineCut: 'Corte a medida',
      lineColor: 'Caras de color (+30 %)', lineFinish: 'Acabado y control (+10 %)', linePeg: 'Perforaciones pegboard',
      lineTotal: 'Total IVA incl.', panels: 'tableros',
      reset: 'Restablecer', resetDone: 'Configuración restablecida', copyLink: 'Copiar enlace', linkCopied: 'Enlace copiado',
      addToCart: 'Añadir al carrito', adding: 'Añadiendo…', cartFail: 'No se pudo añadir al carrito. Inténtelo de nuevo o contáctenos.',
      missingVariant: 'Producto de facturación no encontrado: contáctenos para pedir.',
      cartTitle: 'Expositor a medida', sFront: 'Delante', sBack: 'Detrás', sLeft: 'Izquierda', sRight: 'Derecha', sTop: 'Tapa', hint: 'Haga clic en una cara para elegir su color y sus perforaciones', facesLabel: 'Caras', applyAll: 'Aplicar este color a todas las caras', close: 'Cerrar', color: 'Color', colorsTile: 'Colores', mixed: 'Personalizados', holes: 'agujeros', allFacesName: 'Todas las caras', thickness: 'Espesor',
      madeIn: 'Fabricado en Francia · Madera certificada', contact: '¿Un proyecto especial?', contactLink: 'Contáctenos',
      noWebgl: 'Vista simplificada (3D no disponible en este dispositivo)',
      c_birch: 'Abedul (beige claro)', c_green: 'Verde', c_blue: 'Azul', c_yellow: 'Amarillo', c_orange: 'Naranja',
      c_red: 'Rojo', c_purple: 'Morado', c_black: 'Negro', c_white: 'Blanco'
    },
    it: {
      h1: 'Configura il tuo espositore su misura',
      intro: 'Scegli le dimensioni, le facce in pegboard e il colore di ogni faccia. Prezzo immediato, prodotto in Francia.',
      cardDims: '1 · Dimensioni', width: 'Larghezza', height: 'Altezza', depth: 'Profondità',
      dimsHelp: 'Dimensioni esterne in cm. Larghezza e profondità da 20 a 120 cm, altezza da 20 a 200 cm.',
      cardFaces: '2 · Facce e colori',
      allFaces: 'Tutte le facce', allFacesHelp: 'Applica un colore a tutte le facce in una volta.',
      faceFront: 'Faccia anteriore', faceBack: 'Faccia posteriore', faceLeft: 'Lato sinistro', faceRight: 'Lato destro', faceTop: 'Piano superiore',
      pegboard: 'Pegboard',
      pegHelp: 'Faccia forata su tutta la superficie (fori passanti Ø 6 mm, passo 30 mm) per appendere gli accessori. Una faccia pegboard è da 21 mm, le altre da 15 mm.',
      topHelp: 'Il piano superiore è inserito tra le quattro facce, a filo in alto. Senza base: l’espositore è aperto in basso.',
      colorHelp: 'Betulla inclusa. Altro colore: +30 % sul materiale della faccia.',
      preview: 'Anteprima 3D',
      previewHelp: 'Trascina per ruotare, rotellina o pizzico per lo zoom. Clicca una faccia per regolarla.',
      cardRecap: '2 · Riepilogo',
      outer: 'Dimensioni d’ingombro', pegFaces: 'Facce pegboard', none: 'Nessuna', wood: 'Pannello utilizzato', woodUnit: 'm²',
      total: 'Prezzo totale', priceUnit: 'IVA incl. · spedizione calcolata al pagamento', breakdown: 'Dettaglio del prezzo',
      lineWood: 'Legno', lineThick: 'Spessori (15 mm −10 %, 21 mm +10 %)', lineCut: 'Taglio su misura',
      lineColor: 'Facce colorate (+30 %)', lineFinish: 'Finitura e controllo (+10 %)', linePeg: 'Foratura pegboard',
      lineTotal: 'Totale IVA incl.', panels: 'pannelli',
      reset: 'Reimposta', resetDone: 'Configurazione reimpostata', copyLink: 'Copia link', linkCopied: 'Link copiato',
      addToCart: 'Aggiungi al carrello', adding: 'Aggiunta…', cartFail: 'Impossibile aggiungere al carrello. Riprova o contattaci.',
      missingVariant: 'Prodotto di fatturazione non trovato: contattaci per ordinare.',
      cartTitle: 'Espositore su misura', sFront: 'Fronte', sBack: 'Retro', sLeft: 'Sinistra', sRight: 'Destra', sTop: 'Sopra', hint: 'Clicca una faccia per sceglierne il colore e la foratura', facesLabel: 'Facce', applyAll: 'Applica questo colore a tutte le facce', close: 'Chiudi', color: 'Colore', colorsTile: 'Colori', mixed: 'Personalizzati', holes: 'fori', allFacesName: 'Tutte le facce', thickness: 'Spessore',
      madeIn: 'Prodotto in Francia · Legno certificato', contact: 'Un progetto particolare?', contactLink: 'Contattaci',
      noWebgl: 'Anteprima semplificata (3D non disponibile su questo dispositivo)',
      c_birch: 'Betulla (beige chiaro)', c_green: 'Verde', c_blue: 'Blu', c_yellow: 'Giallo', c_orange: 'Arancione',
      c_red: 'Rosso', c_purple: 'Viola', c_black: 'Nero', c_white: 'Bianco'
    },
    nl: {
      h1: 'Stel uw display op maat samen',
      intro: 'Kies de afmetingen, de pegboardzijden en de kleur van elke zijde. Directe prijs, gemaakt in Frankrijk.',
      cardDims: '1 · Afmetingen', width: 'Breedte', height: 'Hoogte', depth: 'Diepte',
      dimsHelp: 'Buitenmaten in cm. Breedte en diepte 20 tot 120 cm, hoogte 20 tot 200 cm.',
      cardFaces: '2 · Zijden & kleuren',
      allFaces: 'Alle zijden', allFacesHelp: 'Past één kleur toe op alle zijden tegelijk.',
      faceFront: 'Voorzijde', faceBack: 'Achterzijde', faceLeft: 'Linkerzijde', faceRight: 'Rechterzijde', faceTop: 'Bovenblad',
      pegboard: 'Pegboard',
      pegHelp: 'Zijde over het hele oppervlak geperforeerd (doorlopende gaten Ø 6 mm, steek 30 mm) om accessoires op te hangen. Een pegboardzijde is 21 mm dik, de andere 15 mm.',
      topHelp: 'Het bovenblad zit tussen de vier zijden, bovenaan gelijk. Geen bodem: het display is onderaan open.',
      colorHelp: 'Berken inbegrepen. Andere kleur: +30 % op het materiaal van die zijde.',
      preview: '3D-voorbeeld',
      previewHelp: 'Sleep om te draaien, scroll of knijp om te zoomen. Klik op een zijde om die in te stellen.',
      cardRecap: '2 · Overzicht',
      outer: 'Buitenafmetingen', pegFaces: 'Pegboardzijden', none: 'Geen', wood: 'Gebruikte plaat', woodUnit: 'm²',
      total: 'Totaalprijs', priceUnit: 'incl. btw · verzending berekend bij afrekenen', breakdown: 'Prijsdetails',
      lineWood: 'Hout', lineThick: 'Diktes (15 mm −10 %, 21 mm +10 %)', lineCut: 'Zagen op maat',
      lineColor: 'Gekleurde zijden (+30 %)', lineFinish: 'Afwerking & controle (+10 %)', linePeg: 'Pegboardperforatie',
      lineTotal: 'Totaal incl. btw', panels: 'platen',
      reset: 'Opnieuw', resetDone: 'Configuratie hersteld', copyLink: 'Link kopiëren', linkCopied: 'Link gekopieerd',
      addToCart: 'In winkelwagen', adding: 'Toevoegen…', cartFail: 'Toevoegen mislukt. Probeer opnieuw of neem contact op.',
      missingVariant: 'Factuurproduct niet gevonden: neem contact met ons op om te bestellen.',
      cartTitle: 'Display op maat', sFront: 'Voor', sBack: 'Achter', sLeft: 'Links', sRight: 'Rechts', sTop: 'Boven', hint: 'Klik op een zijde om de kleur en perforatie te kiezen', facesLabel: 'Zijden', applyAll: 'Deze kleur op alle zijden toepassen', close: 'Sluiten', color: 'Kleur', colorsTile: 'Kleuren', mixed: 'Op maat', holes: 'gaten', allFacesName: 'Alle zijden', thickness: 'Dikte',
      madeIn: 'Gemaakt in Frankrijk · Gecertificeerd hout', contact: 'Een bijzonder project?', contactLink: 'Neem contact op',
      noWebgl: 'Vereenvoudigd voorbeeld (3D niet beschikbaar op dit apparaat)',
      c_birch: 'Berken (lichtbeige)', c_green: 'Groen', c_blue: 'Blauw', c_yellow: 'Geel', c_orange: 'Oranje',
      c_red: 'Rood', c_purple: 'Paars', c_black: 'Zwart', c_white: 'Wit'
    }
  };
  var LANG = (root.dataset.lang || 'fr').toLowerCase().split('-')[0];
  if (!I18N[LANG]) LANG = 'fr';
  var T = Object.assign({}, I18N.fr, I18N[LANG]);
  var TFR = I18N.fr; // libellés atelier (propriétés de commande) toujours en français

  /* ---------------------------------------------------------------------------
     Constantes métier
  --------------------------------------------------------------------------- */
  var PRICING = {
    pricePerM2: 230,          // €/m² de panneau — identique aux casiers (LC_PRICING.pricePerM2)
    cutPerPanel: 5.75,        // € par panneau découpé (équivalent du « par case » des casiers)
    colorSurcharge: 0.30,     // face teintée (≠ bouleau) : +30 % sur sa matière
    finishFactor: 0.10,       // finition & contrôle : +10 % sur le sous-total
    thicknessFactor: { 15: 0.90, 18: 1.00, 21: 1.10 },
    pegboardPerM2: 250,       // perforations, € par m² de face perforée (ajouté après la finition)
    baseMm: 15,               // faces non perforées et dessus
    pegMm: 21                 // face pegboard
  };
  var PEG = { spacingCm: 3, marginCm: 3, holeDiamMm: 6 };
  var LIMITS = { w: [20, 120], h: [20, 200], d: [20, 120] };
  var SIDE_KEYS = ['front', 'back', 'left', 'right'];
  var FACE_KEYS = SIDE_KEYS.concat(['top']);
  var CHIP_LABEL = { front: 'sFront', back: 'sBack', left: 'sLeft', right: 'sRight', top: 'sTop' };
  var FACE_LABEL = { front: 'faceFront', back: 'faceBack', left: 'faceLeft', right: 'faceRight', top: 'faceTop' };
  var PALETTE = [
    { key: 'birch', hex: '#E8D9BE' }, { key: 'green', hex: '#16A34A' }, { key: 'blue', hex: '#2563EB' },
    { key: 'yellow', hex: '#FACC15' }, { key: 'orange', hex: '#F97316' }, { key: 'red', hex: '#EF4444' },
    { key: 'purple', hex: '#7C3AED' }, { key: 'black', hex: '#1a1a1a' }, { key: 'white', hex: '#FFFFFF' }
  ];
  var colorOf = function (k) { for (var i = 0; i < PALETTE.length; i++) if (PALETTE[i].key === k) return PALETTE[i]; return PALETTE[0]; };
  var colorName = function (k, dict) { return (dict || T)['c_' + k] || k; };
  var shortName = function (k) { return colorName(k).replace(/\s*\(.*\)\s*$/, ''); };
  var STORAGE_KEY = 'aire-presentoir-v1';
  var SHARE_PARAM = 'presentoir';

  var defaults = function () {
    return {
      w: 60, h: 120, d: 40,
      faces: {
        front: { peg: true, color: 'birch' }, back: { peg: true, color: 'birch' },
        left: { peg: false, color: 'birch' }, right: { peg: false, color: 'birch' },
        top: { peg: false, color: 'birch' }
      }
    };
  };

  var clamp = function (v, lo, hi) { return Math.min(hi, Math.max(lo, v)); };
  var r1 = function (v) { return Math.round(v * 10) / 10; };
  function sanitize(src) {
    var s = defaults();
    if (!src || typeof src !== 'object') return s;
    ['w', 'h', 'd'].forEach(function (k) {
      var v = parseFloat(src[k]);
      if (isFinite(v)) s[k] = r1(clamp(v, LIMITS[k][0], LIMITS[k][1]));
    });
    var f = src.faces || src.f;
    if (f && typeof f === 'object') {
      FACE_KEYS.forEach(function (k) {
        var x = f[k]; if (!x) return;
        if (Array.isArray(x)) x = { peg: x[0], color: x[1] };
        if (k !== 'top') s.faces[k].peg = !!x.peg;
        if (PALETTE.some(function (p) { return p.key === x.color; })) s.faces[k].color = x.color;
      });
    }
    return s;
  }
  var compact = function (s) {
    var f = {}; FACE_KEYS.forEach(function (k) { f[k] = [s.faces[k].peg ? 1 : 0, s.faces[k].color]; });
    return { w: s.w, h: s.h, d: s.d, f: f };
  };
  var b64enc = function (o) { return btoa(unescape(encodeURIComponent(JSON.stringify(o)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); };
  var b64dec = function (str) { str = str.replace(/-/g, '+').replace(/_/g, '/'); while (str.length % 4) str += '='; return JSON.parse(decodeURIComponent(escape(atob(str)))); };

  /* ---------------------------------------------------------------------------
     État initial : lien partagé > sauvegarde locale > défaut
  --------------------------------------------------------------------------- */
  var state = defaults();
  (function () {
    try {
      var p = new URLSearchParams(location.search).get(SHARE_PARAM);
      if (p) { state = sanitize(b64dec(p)); return; }
    } catch (e) { /* lien invalide */ }
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) state = sanitize(JSON.parse(raw));
    } catch (e) { /* stockage indisponible */ }
  })();
  var save = function () { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(compact(state))); } catch (e) { /* */ } };

  /* ---------------------------------------------------------------------------
     Géométrie : dimensions de débit de chaque panneau (cm)
     avant/arrière : L × H ; côtés : (P − ép. avant − ép. arrière) × H ;
     dessus : (L − ép. gauche − ép. droite) × (P − ép. avant − ép. arrière), affleurant en haut.
  --------------------------------------------------------------------------- */
  var thickMm = function (k) { return (k !== 'top' && state.faces[k].peg) ? PRICING.pegMm : PRICING.baseMm; };
  var pegGrid = function (L) {
    if (!(L >= 2 * PEG.marginCm)) return [];
    var n = Math.floor((L - 2 * PEG.marginCm) / PEG.spacingCm + 1e-9) + 1;
    var first = (L - (n - 1) * PEG.spacingCm) / 2, out = [];
    for (var i = 0; i < n; i++) out.push(first + i * PEG.spacingCm);
    return out;
  };
  function geometry() {
    var t = {}; FACE_KEYS.forEach(function (k) { t[k] = thickMm(k) / 10; });
    var innerD = r1(state.d - t.front - t.back), innerW = r1(state.w - t.left - t.right);
    var P = {
      front: { len: state.w, hgt: state.h, th: t.front },
      back: { len: state.w, hgt: state.h, th: t.back },
      left: { len: innerD, hgt: state.h, th: t.left },
      right: { len: innerD, hgt: state.h, th: t.right },
      top: { len: innerW, hgt: innerD, th: t.top }
    };
    FACE_KEYS.forEach(function (k) {
      var p = P[k]; p.key = k; p.color = state.faces[k].color; p.peg = k !== 'top' && state.faces[k].peg;
      p.holesX = p.peg ? pegGrid(p.len) : []; p.holesY = p.peg ? pegGrid(p.hgt) : [];
      p.holes = p.holesX.length * p.holesY.length;
      p.areaM2 = p.len * p.hgt / 10000;
    });
    return { t: t, innerW: innerW, innerD: innerD, panels: P };
  }

  /* ---------------------------------------------------------------------------
     Prix
  --------------------------------------------------------------------------- */
  var unitPrice = parseFloat(root.dataset.unitPrice || '1') || 1;
  function pricing(g) {
    var areaM2 = 0, wood = 0, thick = 0, color = 0, peg = 0, pegM2 = 0, colored = 0;
    FACE_KEYS.forEach(function (k) {
      var p = g.panels[k];
      var base = p.areaM2 * PRICING.pricePerM2;
      var tf = PRICING.thicknessFactor[Math.round(p.th * 10)] || 1;
      areaM2 += p.areaM2; wood += base; thick += base * (tf - 1);
      if (p.color !== 'birch') { color += base * tf * PRICING.colorSurcharge; colored++; }
      if (p.peg) { pegM2 += p.areaM2; peg += p.areaM2 * PRICING.pegboardPerM2; }
    });
    var cut = FACE_KEYS.length * PRICING.cutPerPanel;
    var sub = wood + thick + cut + color;
    var finish = sub * PRICING.finishFactor;
    var total = sub + finish + peg;
    var qty = Math.max(1, Math.ceil(total / unitPrice - 1e-9));
    return {
      areaM2: areaM2, wood: wood, thickness: thick, cut: cut, color: color, colored: colored,
      finish: finish, pegboard: peg, pegM2: pegM2, total: total, qty: qty, charged: qty * unitPrice
    };
  }

  /* ---------------------------------------------------------------------------
     Interface
  --------------------------------------------------------------------------- */
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var nf = function (d) { return new Intl.NumberFormat(LANG === 'en' ? 'en-GB' : LANG, { minimumFractionDigits: d, maximumFractionDigits: d }); };
  var f0 = function (v) { return nf(0).format(v); }, f1 = function (v) { return nf(1).format(v); }, f2 = function (v) { return nf(2).format(v); };
  var fDim = function (v) { return Math.abs(v - Math.round(v)) < 1e-6 ? f0(v) : f1(v); };
  var money = function (v, d) { return (d === 0 ? f0(v) : f2(v)) + ' €'; };
  var infoBtn = function (text) {
    return '<button type="button" class="pcfg-info" aria-label="' + esc(text) + '" data-tip="' + esc(text) + '">i</button>';
  };
  var swatches = function (target, current) {
    return '<div class="pcfg-swatches" role="radiogroup">' + PALETTE.map(function (c) {
      var on = c.key === current;
      return '<button type="button" class="pcfg-sw' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" data-target="' + target +
        '" data-color="' + c.key + '" title="' + esc(colorName(c.key)) + '" aria-label="' + esc(colorName(c.key)) + '" style="--sw:' + c.hex + '"></button>';
    }).join('') + '</div>';
  };
  var ICON = {
    reset: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><polyline points="3 3 3 9 9 9"/></svg>',
    link: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7"/><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7"/></svg>',
    check: '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>'
  };

  var dimRow = function (k, label) {
    return '<div class="pcfg-dim">' +
      '<label for="pcfg-' + k + '">' + label + '</label>' +
      '<input type="range" id="pcfg-' + k + '-r" min="' + LIMITS[k][0] + '" max="' + LIMITS[k][1] + '" step="0.5" value="' + state[k] + '" aria-label="' + esc(label) + '">' +
      '<span class="pcfg-num"><input type="number" id="pcfg-' + k + '" min="' + LIMITS[k][0] + '" max="' + LIMITS[k][1] + '" step="0.1" inputmode="decimal" value="' + state[k] + '"><span>cm</span></span>' +
      '</div>';
  };
  var contactUrl = root.dataset.contactUrl || '/pages/projets-sur-mesure';
  root.innerHTML =
    '<header class="pcfg-header"><h1>' + T.h1 + '</h1><p>' + T.intro + '</p>' +
    '<p class="pcfg-trust"><span>' + T.madeIn + '</span><span>' + T.contact + ' <a href="' + esc(contactUrl) + '">' + T.contactLink + '</a></span></p></header>' +
    '<div class="pcfg-layout">' +
      '<div class="pcfg-col pcfg-left">' +
        '<section class="pcfg-card pcfg-card-preview"><h2>' + T.preview + ' ' + infoBtn(T.previewHelp + ' ' + T.pegHelp + ' ' + T.colorHelp) + '</h2>' +
          '<div class="pcfg-view" id="pcfgView" aria-label="' + esc(T.preview) + '"><div class="pcfg-view-hint" id="pcfgHint">' + T.hint + '</div><div class="pcfg-view-dims" id="pcfgViewDims"></div></div>' +
          '<div class="pcfg-chips" role="group" aria-label="' + esc(T.facesLabel) + '"><span class="pcfg-chips-k">' + T.facesLabel + '</span>' +
            FACE_KEYS.map(function (k) { return '<button type="button" class="pcfg-chip" data-open-face="' + k + '" aria-haspopup="dialog"><span class="pcfg-chip-dot"></span>' + T[CHIP_LABEL[k]] + '<span class="pcfg-chip-peg" hidden>PB</span></button>'; }).join('') +
          '</div>' +
        '</section>' +
      '</div>' +
      '<div class="pcfg-col pcfg-right">' +
        '<section class="pcfg-card pcfg-card-dims"><h2>' + T.cardDims + ' ' + infoBtn(T.dimsHelp) + '</h2>' +
          dimRow('w', T.width) + dimRow('h', T.height) + dimRow('d', T.depth) +
        '</section>' +
        '<section class="pcfg-card pcfg-card-recap"><h2>' + T.cardRecap + '</h2>' +
          '<div class="pcfg-tiles">' +
            '<div class="pcfg-tile"><span>' + T.outer + '</span><strong id="pcfgOuter"></strong></div>' +
            '<div class="pcfg-tile"><span>' + T.pegFaces + '</span><strong id="pcfgPegList"></strong></div>' +
            '<div class="pcfg-tile"><span>' + T.colorsTile + '</span><strong id="pcfgColors"></strong></div>' +
            '<div class="pcfg-tile"><span>' + T.wood + '</span><strong id="pcfgArea"></strong></div>' +
          '</div>' +
          '<div class="pcfg-price"><div><span class="pcfg-price-k">' + T.total + ' ' + infoBtn(T.priceUnit) + '</span><strong id="pcfgPrice"></strong></div>' +
            '<div class="pcfg-actions">' +
              '<button type="button" class="pcfg-icon" id="pcfgReset" title="' + esc(T.reset) + '" aria-label="' + esc(T.reset) + '">' + ICON.reset + '</button>' +
              '<button type="button" class="pcfg-icon" id="pcfgLink" title="' + esc(T.copyLink) + '" aria-label="' + esc(T.copyLink) + '">' + ICON.link + '</button>' +
            '</div></div>' +
          '<details class="pcfg-details"><summary>' + T.breakdown + '</summary><div class="pcfg-breakdown" id="pcfgBreakdown"></div></details>' +
          '<button type="button" class="pcfg-cta" id="pcfgAdd">' + T.addToCart + '</button>' +
        '</section>' +
      '</div>' +
    '</div>' +
    '<div class="pcfg-pop" id="pcfgPop" role="dialog" aria-modal="false" hidden></div>' +
    '<div class="pcfg-tip" id="pcfgTip" role="tooltip" hidden></div>' +
    '<div class="pcfg-toast" id="pcfgToast" role="status" aria-live="polite"></div>';

  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  /* Infobulles */
  var tip = $('#pcfgTip');
  var tipOwner = null;
  var hideTip = function () { tip.hidden = true; tipOwner = null; };
  var showTip = function (btn) {
    tip.textContent = btn.getAttribute('data-tip'); tip.hidden = false; tipOwner = btn;
    var r = btn.getBoundingClientRect(), rr = root.getBoundingClientRect();
    if (window.innerWidth <= 860) { tip.style.left = ''; tip.style.top = ''; tip.classList.add('is-sheet'); return; }
    tip.classList.remove('is-sheet');
    var w = Math.min(300, rr.width - 24);
    tip.style.width = w + 'px';
    tip.style.left = clamp(r.left - rr.left - w / 2 + r.width / 2, 8, rr.width - w - 8) + 'px';
    tip.style.top = (r.bottom - rr.top + 8) + 'px';
  };
  root.addEventListener('click', function (e) {
    var b = e.target.closest('.pcfg-info');
    if (b) { e.preventDefault(); if (tipOwner === b) hideTip(); else showTip(b); return; }
    if (!e.target.closest('#pcfgTip')) hideTip();
  });
  root.addEventListener('mouseover', function (e) { var b = e.target.closest && e.target.closest('.pcfg-info'); if (b && window.matchMedia('(hover:hover)').matches) showTip(b); });
  root.addEventListener('mouseout', function (e) { var b = e.target.closest && e.target.closest('.pcfg-info'); if (b && window.matchMedia('(hover:hover)').matches) hideTip(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideTip(); });

  var toastTimer = null;
  var toast = function (msg, kind) {
    var t = $('#pcfgToast'); t.textContent = msg; t.className = 'pcfg-toast is-on' + (kind ? ' is-' + kind : '');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.className = 'pcfg-toast'; }, 2600);
  };

  /* Dimensions */
  ['w', 'h', 'd'].forEach(function (k) {
    var num = $('#pcfg-' + k), rng = $('#pcfg-' + k + '-r');
    rng.addEventListener('input', function () { state[k] = r1(parseFloat(rng.value)); num.value = state[k]; update(); });
    num.addEventListener('input', function () {
      var v = parseFloat(num.value);
      if (!isFinite(v) || v < LIMITS[k][0] || v > LIMITS[k][1]) { num.classList.add('is-invalid'); return; }
      num.classList.remove('is-invalid'); state[k] = r1(v); rng.value = state[k]; update();
    });
    num.addEventListener('change', function () {
      var v = parseFloat(num.value); if (!isFinite(v)) v = state[k];
      state[k] = r1(clamp(v, LIMITS[k][0], LIMITS[k][1])); num.value = state[k]; rng.value = state[k];
      num.classList.remove('is-invalid'); update();
    });
  });

  /* Faces : pegboard + couleurs */
  /* Fenêtre d'une face (ouverte par un clic sur la face dans l'aperçu ou sur son bouton) */
  var pop = $('#pcfgPop');
  var popFace = null, popAnchor = null;
  var renderPop = function () {
    var k = popFace, isTop = k === 'top', p = last.g.panels[k];
    pop.setAttribute('aria-label', T[FACE_LABEL[k]]);
    pop.innerHTML =
      '<div class="pcfg-pop-head"><strong>' + T[FACE_LABEL[k]] + '</strong><span class="pcfg-badge">' + thickMm(k) + ' mm</span>' +
        '<button type="button" class="pcfg-pop-close" data-pop-close aria-label="' + esc(T.close) + '">×</button></div>' +
      '<p class="pcfg-pop-meta">' + fDim(p.len) + ' × ' + fDim(p.hgt) + ' cm' + (p.peg ? ' · ' + p.holes + ' ' + T.holes : '') + '</p>' +
      (isTop ? '<p class="pcfg-pop-note">' + T.topHelp + '</p>'
        : '<label class="pcfg-switch pcfg-pop-peg"><input type="checkbox" data-peg="' + k + '"' + (state.faces[k].peg ? ' checked' : '') + '><span class="pcfg-switch-ui" aria-hidden="true"></span><span>' + T.pegboard + '</span> ' + infoBtn(T.pegHelp) + '</label>') +
      '<div class="pcfg-pop-label">' + T.color + ' : <strong>' + esc(colorName(state.faces[k].color)) + '</strong> ' + infoBtn(T.colorHelp) + '</div>' +
      swatches(k, state.faces[k].color) +
      '<button type="button" class="pcfg-pop-all" data-apply-all>' + T.applyAll + '</button>';
  };
  var placePop = function () {
    if (!popAnchor) return;
    if (window.innerWidth <= 860) { pop.classList.add('is-sheet'); pop.style.left = ''; pop.style.top = ''; return; }
    pop.classList.remove('is-sheet');
    var rr = root.getBoundingClientRect(), w = pop.offsetWidth, h = pop.offsetHeight;
    var card = $('.pcfg-card-preview').getBoundingClientRect(), maxX = card.right - rr.left - w - 8; // reste sur l'aperçu
    var x = popAnchor.x - rr.left + 14, y = popAnchor.y - rr.top - 20;
    if (x > maxX) x = popAnchor.x - rr.left - w - 14;                        // à gauche du clic si pas de place à droite
    x = clamp(x, Math.max(8, card.left - rr.left + 8), Math.max(8, maxX));
    var viewTop = -rr.top + 8, viewBottom = -rr.top + window.innerHeight - 8;  // reste dans la fenêtre visible
    y = clamp(y, Math.max(0, viewTop), Math.max(viewTop, viewBottom - h));
    pop.style.left = x + 'px'; pop.style.top = y + 'px';
  };
  var openPop = function (k, x, y) {
    hideTip();
    popFace = k; popAnchor = { x: x, y: y };
    renderPop(); pop.hidden = false; placePop();
    if (view && view.setSelected) view.setSelected(k);
    $$('.pcfg-chip').forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-open-face') === k); c.setAttribute('aria-expanded', c.getAttribute('data-open-face') === k); });
    var hint = $('#pcfgHint'); if (hint) hint.classList.add('is-hidden');
    var first = pop.querySelector('.pcfg-sw.is-on'); if (first && window.innerWidth > 860) first.focus({ preventScroll: true });
  };
  var closePop = function () {
    if (pop.hidden) return;
    pop.hidden = true; popFace = null; popAnchor = null;
    if (view && view.setSelected) view.setSelected(null);
    $$('.pcfg-chip').forEach(function (c) { c.classList.remove('is-on'); c.setAttribute('aria-expanded', 'false'); });
  };
  root.addEventListener('change', function (e) {
    var k = e.target.getAttribute && e.target.getAttribute('data-peg');
    if (!k) return;
    state.faces[k].peg = e.target.checked; update();
  });
  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-open-face]');
    if (chip) {
      var k = chip.getAttribute('data-open-face');
      if (popFace === k) { closePop(); return; }
      var r = chip.getBoundingClientRect(); openPop(k, r.left, r.bottom + 24); return;
    }
    if (e.target.closest('[data-pop-close]')) { closePop(); return; }
    if (e.target.closest('[data-apply-all]')) {
      var c = state.faces[popFace].color; FACE_KEYS.forEach(function (f) { state.faces[f].color = c; }); update(); return;
    }
    var sw = e.target.closest('.pcfg-sw');
    if (sw) { state.faces[sw.getAttribute('data-target')].color = sw.getAttribute('data-color'); update(); return; }
    // clic ailleurs (hors fenêtre et hors aperçu, qui gère ses propres clics) → fermer
    if (!e.target.closest('#pcfgPop') && !e.target.closest('#pcfgView') && !e.target.closest('.pcfg-info')) closePop();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePop(); });
  document.addEventListener('pointerdown', function (e) { if (!pop.hidden && !root.contains(e.target)) closePop(); });
  window.addEventListener('resize', function () { if (!pop.hidden) placePop(); });
  var selectFace = function (k, ev) {
    if (!k) { closePop(); return; }
    if (popFace === k && !pop.hidden) { popAnchor = { x: ev.clientX, y: ev.clientY }; placePop(); return; }
    openPop(k, ev ? ev.clientX : 0, ev ? ev.clientY : 0);
  };

  /* Liens, réinitialisation */
  var shareUrl = function () {
    var u = new URL(location.href);
    u.searchParams.delete('preview_theme_id');
    u.searchParams.set(SHARE_PARAM, b64enc(compact(state)));
    return u.toString();
  };
  $('#pcfgLink').addEventListener('click', function () {
    var url = shareUrl(), done = function () { toast(T.linkCopied, 'ok'); };
    try { history.replaceState(null, '', url); } catch (e) { /* */ }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { window.prompt(T.copyLink, url); });
    else window.prompt(T.copyLink, url);
  });
  $('#pcfgReset').addEventListener('click', function () {
    state = defaults();
    ['w', 'h', 'd'].forEach(function (k) { $('#pcfg-' + k).value = state[k]; $('#pcfg-' + k + '-r').value = state[k]; });
    try { var u = new URL(location.href); u.searchParams.delete(SHARE_PARAM); history.replaceState(null, '', u.toString()); } catch (e) { /* */ }
    closePop(); update(); toast(T.resetDone);
  });

  /* ---------------------------------------------------------------------------
     Mise à jour
  --------------------------------------------------------------------------- */
  var last = null;
  function update() {
    var g = geometry(), pr = pricing(g);
    last = { g: g, pr: pr };
    $$('.pcfg-chip').forEach(function (c) {
      var k = c.getAttribute('data-open-face');
      c.querySelector('.pcfg-chip-dot').style.background = colorOf(state.faces[k].color).hex;
      c.querySelector('.pcfg-chip-peg').hidden = !(k !== 'top' && state.faces[k].peg);
    });
    var same = FACE_KEYS.every(function (k) { return state.faces[k].color === state.faces.front.color; });
    $('#pcfgColors').textContent = same ? shortName(state.faces.front.color) : T.mixed;
    if (popFace && !pop.hidden) { var foc = document.activeElement && pop.contains(document.activeElement) ? document.activeElement.getAttribute('data-color') : null; renderPop(); placePop(); if (foc) { var f = pop.querySelector('.pcfg-sw[data-color="' + foc + '"]'); if (f) f.focus({ preventScroll: true }); } }

    var dimsTxt = fDim(state.w) + ' × ' + fDim(state.h) + ' × ' + fDim(state.d) + ' cm';
    $('#pcfgOuter').textContent = dimsTxt;
    $('#pcfgViewDims').textContent = T.width[0] + ' ' + fDim(state.w) + ' · ' + T.height[0] + ' ' + fDim(state.h) + ' · ' + T.depth[0] + ' ' + fDim(state.d) + ' cm';
    var pegs = SIDE_KEYS.filter(function (k) { return state.faces[k].peg; });
    $('#pcfgPegList').textContent = pegs.length ? pegs.map(function (k) { return T[FACE_LABEL[k]]; }).join(', ') : T.none;
    $('#pcfgArea').textContent = f2(pr.areaM2) + ' ' + T.woodUnit;
    $('#pcfgPrice').textContent = money(pr.charged, 0);

    var line = function (l, v, sign) { return '<span>' + l + '</span><span>' + (sign ? (v < 0 ? '− ' : '+ ') : '') + money(Math.abs(v)) + '</span>'; };
    $('#pcfgBreakdown').innerHTML =
      line(T.lineWood + ' (' + f2(pr.areaM2) + ' m² × ' + PRICING.pricePerM2 + ' €)', pr.wood) +
      (Math.abs(pr.thickness) > 0.004 ? line(T.lineThick, pr.thickness, true) : '') +
      line(T.lineCut + ' (' + FACE_KEYS.length + ' ' + T.panels + ' × ' + f2(PRICING.cutPerPanel) + ' €)', pr.cut, true) +
      (pr.color > 0 ? line(T.lineColor, pr.color, true) : '') +
      line(T.lineFinish, pr.finish, true) +
      (pr.pegboard > 0 ? line(T.linePeg + ' (' + f2(pr.pegM2) + ' m² × ' + PRICING.pegboardPerM2 + ' €)', pr.pegboard, true) : '') +
      '<span class="pcfg-bd-total">' + T.lineTotal + '</span><span class="pcfg-bd-total">' + money(pr.charged, 0) + '</span>';

    save();
    if (view) view.update(g);
  }

  /* ---------------------------------------------------------------------------
     Aperçu 3D (three.js r128) — repli SVG
  --------------------------------------------------------------------------- */
  var view = null;
  var viewEl = $('#pcfgView');

  function webglOk() {
    if (!window.THREE) return false;
    try { var c = document.createElement('canvas'); return !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl'))); } catch (e) { return false; }
  }

  function create3D(container, onPick) {
    var THREE = window.THREE;
    var canvas = document.createElement('canvas');
    canvas.className = 'pcfg-canvas';
    container.appendChild(canvas);
    var renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, preserveDrawingBuffer: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.0;
    renderer.setClearColor(0xffffff, 1);
    var maxAniso = renderer.capabilities.getMaxAnisotropy();

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(28, 1, 0.05, 80);
    scene.add(new THREE.HemisphereLight(0xffffff, 0xcfc7b6, 0.6));
    var sun = new THREE.DirectionalLight(0xfff6e8, 1.0);
    sun.position.set(-2.4, 4.4, 3.2); sun.castShadow = true;
    sun.shadow.mapSize.set(2048, 2048); sun.shadow.bias = -0.0005; sun.shadow.normalBias = 0.01; sun.shadow.radius = 4;
    var sc = sun.shadow.camera; sc.left = -2.5; sc.right = 2.5; sc.top = 2.5; sc.bottom = -2.5; sc.near = 0.5; sc.far = 12;
    scene.add(sun);
    var fill = new THREE.DirectionalLight(0xe8f0ff, 0.35); fill.position.set(3, 2, 2.5); scene.add(fill);
    var rim = new THREE.DirectionalLight(0xffffff, 0.25); rim.position.set(0.5, 3, -4); scene.add(rim);
    var ground = new THREE.Mesh(new THREE.PlaneGeometry(40, 40), new THREE.ShadowMaterial({ opacity: 0.22 }));
    ground.rotation.x = -Math.PI / 2; ground.receiveShadow = true; scene.add(ground);

    var group = new THREE.Group(); scene.add(group);
    var meshes = [];
    var edgeMat = new THREE.MeshStandardMaterial({ color: 0xd8c39e, roughness: 0.85, metalness: 0 });

    // Texture d'une face : couleur (veinage pour le bouleau) + trous pegboard aux positions exactes
    function faceTexture(p) {
      var pxPerCm = clamp(1400 / Math.max(p.len, p.hgt), 4, 12);
      var W = Math.max(16, Math.round(p.len * pxPerCm)), H = Math.max(16, Math.round(p.hgt * pxPerCm));
      var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
      var c = cv.getContext('2d');
      var col = colorOf(p.color);
      c.fillStyle = col.hex; c.fillRect(0, 0, W, H);
      if (p.color === 'birch') {
        // veinage léger, dans le sens de la hauteur pour les faces, de la longueur pour le dessus
        var vertical = p.key !== 'top';
        var n = vertical ? W : H;
        var seed = 7;
        var rnd = function () { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; };
        for (var i = 0; i < n; i += 2 + rnd() * 5) {
          c.strokeStyle = 'rgba(150,110,60,' + (0.03 + rnd() * 0.07) + ')';
          c.lineWidth = 0.6 + rnd() * 1.6;
          c.beginPath();
          if (vertical) { c.moveTo(i, 0); c.bezierCurveTo(i + rnd() * 6 - 3, H * 0.33, i + rnd() * 6 - 3, H * 0.66, i + rnd() * 4 - 2, H); }
          else { c.moveTo(0, i); c.bezierCurveTo(W * 0.33, i + rnd() * 6 - 3, W * 0.66, i + rnd() * 6 - 3, W, i + rnd() * 4 - 2); }
          c.stroke();
        }
      }
      if (p.peg) {
        var r = Math.max(1.2, (PEG.holeDiamMm / 20) * pxPerCm);
        var dark = (p.color === 'black') ? '#000' : 'rgba(25,22,18,0.92)';
        p.holesX.forEach(function (x) {
          p.holesY.forEach(function (y) {
            var cx = x * pxPerCm, cy = y * pxPerCm;
            c.fillStyle = dark; c.beginPath(); c.arc(cx, cy, r, 0, Math.PI * 2); c.fill();
            if (p.color !== 'black') { c.strokeStyle = 'rgba(0,0,0,0.18)'; c.lineWidth = 1; c.beginPath(); c.arc(cx, cy, r + 0.8, Math.PI * 0.8, Math.PI * 1.9); c.stroke(); }
          });
        });
      }
      var tex = new THREE.CanvasTexture(cv);
      tex.encoding = THREE.sRGBEncoding; tex.anisotropy = maxAniso;
      return tex;
    }

    var cam = { theta: -0.62, phi: 1.12, radius: 3, target: new THREE.Vector3(0, 0.6, 0), fitR: 3 };
    var dims = { w: 0.6, h: 1.2, d: 0.4 };
    var placeCamera = function () {
      cam.phi = clamp(cam.phi, 0.25, 1.52);
      cam.radius = clamp(cam.radius, cam.fitR * 0.45, cam.fitR * 2.2);
      var s = Math.sin(cam.phi);
      camera.position.set(cam.target.x + cam.radius * s * Math.sin(cam.theta), cam.target.y + cam.radius * Math.cos(cam.phi), cam.target.z + cam.radius * s * Math.cos(cam.theta));
      camera.lookAt(cam.target);
    };
    var fit = function () {
      var rect = container.getBoundingClientRect();
      var aspect = Math.max(0.3, rect.width / Math.max(1, rect.height));
      var R = 0.5 * Math.sqrt(dims.w * dims.w + dims.h * dims.h + dims.d * dims.d);
      var vfov = camera.fov * Math.PI / 180, hfov = 2 * Math.atan(Math.tan(vfov / 2) * aspect);
      cam.fitR = 1.02 * R / Math.sin(Math.min(vfov, hfov) / 2);
      cam.target.set(0, dims.h / 2, 0);
    };

    var dirty = true, hovered = null, selected = null, outline = null;
    var outlineMat = new THREE.LineBasicMaterial({ color: 0x0d6efd, depthTest: false, transparent: true });
    var applySelected = function () {
      if (outline) { if (outline.parent) outline.parent.remove(outline); outline.geometry.dispose(); outline = null; }
      var m = null; meshes.forEach(function (x) { if (x.userData.face === selected) m = x; });
      if (m) { outline = new THREE.LineSegments(new THREE.EdgesGeometry(m.geometry), outlineMat); outline.renderOrder = 10; m.add(outline); }
      requestRender();
    };
    var requestRender = function () { dirty = true; };
    var loop = function () {
      if (dirty) { dirty = false; renderer.render(scene, camera); }
      raf = requestAnimationFrame(loop);
    };
    var raf = requestAnimationFrame(loop);

    var resize = function () {
      var rect = container.getBoundingClientRect();
      if (rect.width < 2 || rect.height < 2) return;
      renderer.setSize(rect.width, rect.height, false);
      camera.aspect = rect.width / rect.height; camera.updateProjectionMatrix();
      var prevFit = cam.fitR; fit(); cam.radius *= cam.fitR / prevFit; placeCamera(); requestRender();
    };
    if (window.ResizeObserver) new ResizeObserver(resize).observe(container); else window.addEventListener('resize', resize);

    function build(g) {
      meshes.forEach(function (m) {
        group.remove(m); m.geometry.dispose();
        m.material.filter(function (mt, i, arr) { return arr.indexOf(mt) === i; }).forEach(function (mt) { if (mt !== edgeMat) { if (mt.map) mt.map.dispose(); mt.dispose(); } });
      });
      meshes = [];
      var W = state.w / 100, H = state.h / 100, D = state.d / 100, t = {};
      FACE_KEYS.forEach(function (k) { t[k] = g.panels[k].th / 100; });
      var add = function (p, sx, sy, sz, pos, rotY, rotX) {
        var geo = new THREE.BoxGeometry(sx, sy, sz);
        var tex = faceTexture(p);
        var face = new THREE.MeshStandardMaterial({ map: tex, roughness: p.color === 'birch' ? 0.62 : 0.5, metalness: 0 });
        // ordre BoxGeometry : +x, −x, +y, −y, +z, −z → grandes faces en ±z
        // chants : bouleau naturel, ou teintés dans la couleur de la face (v3)
        var edge = p.color === 'birch' ? edgeMat
          : new THREE.MeshStandardMaterial({ color: new THREE.Color(colorOf(p.color).hex).convertSRGBToLinear(), roughness: 0.7, metalness: 0 });
        var mats = [edge, edge, edge, edge, face, face];
        var m = new THREE.Mesh(geo, mats);
        m.position.copy(pos); if (rotY) m.rotation.y = rotY; if (rotX) m.rotation.x = rotX;
        m.castShadow = true; m.receiveShadow = true; m.userData.face = p.key;
        group.add(m); meshes.push(m);
      };
      var P = g.panels;
      add(P.front, W, H, t.front, new THREE.Vector3(0, H / 2, D / 2 - t.front / 2));
      add(P.back, W, H, t.back, new THREE.Vector3(0, H / 2, -D / 2 + t.back / 2));
      var zc = (t.back - t.front) / 2; // centre de la zone entre avant et arrière
      add(P.left, P.left.len / 100, H, t.left, new THREE.Vector3(-W / 2 + t.left / 2, H / 2, zc), Math.PI / 2);
      add(P.right, P.right.len / 100, H, t.right, new THREE.Vector3(W / 2 - t.right / 2, H / 2, zc), Math.PI / 2);
      add(P.top, P.top.len / 100, P.top.hgt / 100, t.top, new THREE.Vector3((t.left - t.right) / 2, H - t.top / 2, zc), 0, -Math.PI / 2);
      var changed = Math.abs(dims.w - W) + Math.abs(dims.h - H) + Math.abs(dims.d - D) > 1e-6;
      dims = { w: W, h: H, d: D };
      if (changed || !build.done) { var prev = cam.fitR; fit(); cam.radius = build.done ? cam.radius * cam.fitR / prev : cam.fitR; }
      build.done = true;
      if (hovered) hovered = null;
      applySelected();
      placeCamera(); requestRender();
    }

    // Orbite / zoom / sélection
    var ray = new THREE.Raycaster(), ndc = new THREE.Vector2();
    var pick = function (ev) {
      var r = canvas.getBoundingClientRect();
      ndc.set(((ev.clientX - r.left) / r.width) * 2 - 1, -((ev.clientY - r.top) / r.height) * 2 + 1);
      ray.setFromCamera(ndc, camera);
      var hit = ray.intersectObjects(meshes, false)[0];
      return hit ? hit.object : null;
    };
    var setHover = function (m) {
      if (hovered === m) return;
      if (hovered) hovered.material[4].emissive.setHex(0x000000);
      hovered = m;
      if (m) m.material[4].emissive.setHex(0x1c1c1c);
      canvas.style.cursor = m ? 'pointer' : 'grab';
      requestRender();
    };
    var pointers = {}, drag = null, pinch = null;
    canvas.addEventListener('pointerdown', function (e) {
      canvas.setPointerCapture(e.pointerId);
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointers);
      if (ids.length === 1) drag = { x: e.clientX, y: e.clientY, sx: e.clientX, sy: e.clientY, moved: false };
      else if (ids.length === 2) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        pinch = { dist: Math.hypot(a.x - b.x, a.y - b.y), r: cam.radius }; drag = null;
      }
    });
    canvas.addEventListener('pointermove', function (e) {
      if (pointers[e.pointerId]) pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (pinch) {
        var ids = Object.keys(pointers); if (ids.length < 2) return;
        var a = pointers[ids[0]], b = pointers[ids[1]];
        var dd = Math.hypot(a.x - b.x, a.y - b.y);
        cam.radius = pinch.r * pinch.dist / Math.max(10, dd); placeCamera(); requestRender(); return;
      }
      if (drag) {
        var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (Math.abs(e.clientX - drag.sx) + Math.abs(e.clientY - drag.sy) > 4) drag.moved = true;
        drag.x = e.clientX; drag.y = e.clientY;
        if (drag.moved) { cam.theta -= dx * 0.008; cam.phi -= dy * 0.006; placeCamera(); canvas.style.cursor = 'grabbing'; requestRender(); }
        return;
      }
      if (e.pointerType === 'mouse') setHover(pick(e));
    });
    var end = function (e) {
      var wasDrag = drag;
      delete pointers[e.pointerId];
      if (Object.keys(pointers).length < 2) pinch = null;
      if (wasDrag && e.type === 'pointerup' && !wasDrag.moved && onPick) { var m = pick(e); onPick(m ? m.userData.face : null, e); }
      drag = null; canvas.style.cursor = hovered ? 'pointer' : 'grab';
    };
    canvas.addEventListener('pointerup', end);
    canvas.addEventListener('pointercancel', end);
    canvas.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse' && !drag) setHover(null); });
    canvas.addEventListener('wheel', function (e) {
      e.preventDefault();
      cam.radius *= Math.exp(e.deltaY * 0.0012); placeCamera(); requestRender();
    }, { passive: false });

    resize();
    return { update: build, kind: '3d', setSelected: function (k) { selected = k; applySelected(); } };
  }

  // Repli sans WebGL : vue axonométrique simple (avant, côté droit, dessus)
  function createSVG(container, onPick) {
    var note = document.createElement('p'); note.className = 'pcfg-fallback-note'; note.textContent = T.noWebgl;
    var holder = document.createElement('div'); holder.className = 'pcfg-svg';
    container.appendChild(holder); container.appendChild(note);
    var selected = null;
    holder.addEventListener('click', function (e) { var f = e.target.closest('[data-face]'); if (onPick) onPick(f ? f.getAttribute('data-face') : null, e); });
    var markSel = function () { holder.querySelectorAll('[data-face]').forEach(function (n) { n.classList.toggle('is-sel', n.getAttribute('data-face') === selected); }); };
    function build(g) {
      var W = state.w, H = state.h, D = state.d;
      var k = 0.5, cx = Math.cos(Math.PI / 6) * k, cy = Math.sin(Math.PI / 6) * k;
      var P = function (x, y, z) { return [x + z * cx, -y - z * cy]; }; // z = profondeur vers l'arrière
      var pts = function (arr) { return arr.map(function (p) { return p[0].toFixed(2) + ',' + p[1].toFixed(2); }).join(' '); };
      var shade = function (hex, f) {
        var n = parseInt(hex.slice(1), 16), r = (n >> 16) & 255, gg = (n >> 8) & 255, b = n & 255;
        return 'rgb(' + Math.round(r * f) + ',' + Math.round(gg * f) + ',' + Math.round(b * f) + ')';
      };
      var holes = function (p, map, color) {
        if (!p.peg) return '';
        var out = '', rr = 0.35;
        p.holesX.forEach(function (x) { p.holesY.forEach(function (y) { var q = map(x, y); out += '<circle cx="' + q[0].toFixed(2) + '" cy="' + q[1].toFixed(2) + '" r="' + rr + '" fill="' + color + '"/>'; }); });
        return out;
      };
      var Pn = g.panels, tL = g.t.left, tR = g.t.right, tF = g.t.front, tB = g.t.back;
      var front = '<g data-face="front"><polygon points="' + pts([P(0, 0, 0), P(W, 0, 0), P(W, H, 0), P(0, H, 0)]) + '" fill="' + colorOf(Pn.front.color).hex + '" stroke="#333" stroke-width="0.25"/>' +
        holes(Pn.front, function (x, y) { return P(x, H - y, 0); }, '#222') + '</g>';
      var right = '<g data-face="right"><polygon points="' + pts([P(W, 0, 0), P(W, 0, D), P(W, H, D), P(W, H, 0)]) + '" fill="' + shade(colorOf(Pn.right.color).hex, 0.82) + '" stroke="#333" stroke-width="0.25"/>' +
        holes(Pn.right, function (x, y) { return P(W, H - y, tF + x); }, '#222') + '</g>';
      // dessus : liseré des faces (épaisseurs) + panneau inséré
      // chants supérieurs de chaque face, dans la couleur de la face (v3)
      var edgeHex = function (k) { return Pn[k].color === 'birch' ? '#d8c39e' : colorOf(Pn[k].color).hex; };
      var rim = function (k, q) { return '<polygon data-face="' + k + '" points="' + pts(q) + '" fill="' + shade(edgeHex(k), 0.9) + '" stroke="#333" stroke-width="0.15"/>'; };
      var top = '<g data-face="top"><polygon points="' + pts([P(0, H, 0), P(W, H, 0), P(W, H, D), P(0, H, D)]) + '" fill="#ccc" stroke="#333" stroke-width="0.25"/>' +
        rim('back', [P(0, H, D - tB), P(W, H, D - tB), P(W, H, D), P(0, H, D)]) +
        rim('left', [P(0, H, tF), P(tL, H, tF), P(tL, H, D - tB), P(0, H, D - tB)]) +
        rim('right', [P(W - tR, H, tF), P(W, H, tF), P(W, H, D - tB), P(W - tR, H, D - tB)]) +
        rim('front', [P(0, H, 0), P(W, H, 0), P(W, H, tF), P(0, H, tF)]) +
        '<polygon points="' + pts([P(tL, H, tF), P(W - tR, H, tF), P(W - tR, H, D - tB), P(tL, H, D - tB)]) + '" fill="' + shade(colorOf(Pn.top.color).hex, 0.95) + '" stroke="#555" stroke-width="0.15"/></g>';
      var minX = 0, maxX = W + D * cx, minY = -H - D * cy, maxY = 0, pad = 6;
      holder.innerHTML = '<svg viewBox="' + (minX - pad) + ' ' + (minY - pad) + ' ' + (maxX - minX + 2 * pad) + ' ' + (maxY - minY + 2 * pad) + '" role="img" aria-label="' + esc(T.preview) + '">' + right + top + front + '</svg>';
    }
    return { update: function (g) { build(g); markSel(); }, kind: 'svg', setSelected: function (k) { selected = k; markSel(); } };
  }

  function initView() {
    var onPick = function (k, ev) { selectFace(k, ev); };
    if (webglOk()) {
      try { view = create3D(viewEl, onPick); } catch (e) { console.warn('pcfg 3D', e); view = null; }
    }
    if (!view) view = createSVG(viewEl, onPick);
    view.update(last ? last.g : geometry());
  }

  /* ---------------------------------------------------------------------------
     Colonne collante sous l'en-tête du thème (même méthode que les casiers V59)
  --------------------------------------------------------------------------- */
  var scrollHost = (function () {
    for (var n = root.parentElement; n && n !== document.body; n = n.parentElement) {
      if (/(auto|scroll)/.test(getComputedStyle(n).overflowY)) return n;
    }
    return null;
  })();
  var setStickyTop = function () {
    var hostTop = scrollHost ? scrollHost.getBoundingClientRect().top : 0, h = 0;
    document.querySelectorAll('header, sticky-header, .header-wrapper').forEach(function (x) {
      var cs = getComputedStyle(x);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      var r = x.getBoundingClientRect();
      if (r.height > 0 && r.bottom > hostTop && r.top <= hostTop + 80) h = Math.max(h, r.bottom - hostTop);
    });
    root.style.setProperty('--pcfg-sticky-top', Math.round(Math.max(12, h + 12)) + 'px');
  };
  setStickyTop();
  (scrollHost || window).addEventListener('scroll', setStickyTop, { passive: true });
  window.addEventListener('resize', setStickyTop);

  /* ---------------------------------------------------------------------------
     Panier
  --------------------------------------------------------------------------- */
  function cartPayload() {
    var g = last.g, pr = last.pr;
    var faceFr = function (k) { return TFR[FACE_LABEL[k]]; };
    var pegs = SIDE_KEYS.filter(function (k) { return state.faces[k].peg; });
    var same = FACE_KEYS.every(function (k) { return state.faces[k].color === state.faces.front.color; });
    var colors = same ? T.allFacesName + ' ' + colorName(state.faces.front.color)
      : FACE_KEYS.map(function (k) { return T[FACE_LABEL[k]] + ' ' + colorName(state.faces[k].color); }).join(', ');
    var dimsTxt = fDim(state.w) + ' × ' + fDim(state.h) + ' × ' + fDim(state.d) + ' cm';
    var cfg = {
      type: 'presentoir', version: 1,
      outer_cm: { width: state.w, height: state.h, depth: state.d },
      assembly: 'Faces avant et arrière pleine largeur ; côtés gauche/droit entre avant et arrière ; dessus inséré entre les 4 faces, affleurant en haut ; pas de base.',
      panels: FACE_KEYS.map(function (k) {
        var p = g.panels[k];
        return {
          face: k, label: faceFr(k),
          cut_mm: [Math.round(p.len * 10), Math.round(p.hgt * 10)],
          thickness_mm: Math.round(p.th * 10),
          pegboard: p.peg ? { through_holes: true, hole_diameter_mm: PEG.holeDiamMm, spacing_mm: PEG.spacingCm * 10, margin_mm: PEG.marginCm * 10, holes_x: p.holesX.length, holes_y: p.holesY.length, holes: p.holes } : null,
          color: { key: p.color, name: colorName(p.color, TFR) }
        };
      }),
      dims_note: 'cut_mm = [longueur, hauteur] ; dessus = [largeur intérieure, profondeur intérieure]',
      pricing: {
        area_m2: +pr.areaM2.toFixed(4), wood_EUR: +pr.wood.toFixed(2), thickness_EUR: +pr.thickness.toFixed(2), cut_EUR: +pr.cut.toFixed(2),
        color_EUR: +pr.color.toFixed(2), finish_EUR: +pr.finish.toFixed(2), pegboard_EUR: +pr.pegboard.toFixed(2),
        total_EUR: +pr.total.toFixed(2), charged_EUR: +pr.charged.toFixed(2), unit_price_EUR: unitPrice, quantity: pr.qty
      }
    };
    var props = {
      Dimensions: dimsTxt + ' (L × H × P)',
      Faces_pegboard: pegs.length ? pegs.map(function (k) { return T[FACE_LABEL[k]]; }).join(', ') : T.none,
      Epaisseurs: FACE_KEYS.map(function (k) { return T[FACE_LABEL[k]] + ' ' + thickMm(k) + ' mm'; }).join(', '),
      Couleurs: colors,
      Debit: FACE_KEYS.map(function (k) { var p = g.panels[k]; return faceFr(k) + ' ' + Math.round(p.len * 10) + '×' + Math.round(p.hgt * 10) + '×' + Math.round(p.th * 10); }).join(' · '),
      _Prix_total_EUR: pr.charged.toFixed(2),
      _Bois_EUR: pr.wood.toFixed(2), _Epaisseur_EUR: pr.thickness.toFixed(2), _Decoupe_EUR: pr.cut.toFixed(2),
      _Majoration_couleur_EUR: pr.color.toFixed(2), _Finition_EUR: pr.finish.toFixed(2), _Perforations_pegboard_EUR: pr.pegboard.toFixed(2),
      _cart_title: T.cartTitle + ' ' + dimsTxt + (pegs.length ? ' · pegboard ' + pegs.map(function (k) { return T[FACE_LABEL[k]]; }).join('+') : '') + ' · ' + (same ? shortName(state.faces.front.color) : FACE_KEYS.map(function (k) { return shortName(state.faces[k].color); }).filter(function (v, i, a) { return a.indexOf(v) === i; }).join('/')),
      _config: JSON.stringify(cfg)
    };
    try { props._Lien_configuration = shareUrl(); } catch (e) { /* */ }
    return { id: parseInt(root.dataset.variantId, 10), quantity: pr.qty, properties: props };
  }
  window.AirePresentoir = { getState: function () { return JSON.parse(JSON.stringify(state)); }, getPricing: function () { return last && last.pr; }, cartPayload: cartPayload };

  $('#pcfgAdd').addEventListener('click', function () {
    var btn = this;
    var vid = parseInt(root.dataset.variantId || '0', 10);
    if (!vid) { toast(T.missingVariant, 'error'); return; }
    var item = cartPayload();
    btn.disabled = true; var label = btn.textContent; btn.textContent = T.adding;
    fetch(root.dataset.cartAddUrl || '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) { /* */ }
      window.location.href = root.dataset.cartUrl || '/cart';
    }).catch(function (err) {
      console.error('pcfg cart', err);
      btn.disabled = false; btn.textContent = label; toast(T.cartFail, 'error');
    });
  });

  /* Démarrage */
  update();
  var startView = function () { if (!view) initView(); };
  if (window.THREE) startView();
  else {
    // three.min.js est chargé en defer : on attend la fin du chargement, avec repli SVG
    window.addEventListener('load', startView);
    setTimeout(startView, 4000);
  }
})();
